import { render } from "./Step2Appearance.vue?vue&type=template&id=19a54dc6&scoped=true"
const script = {}

import "./Step2Appearance.vue?vue&type=style&index=0&id=19a54dc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a54dc6"]])

export default __exports__